import { render } from "./MediaItem.vue?vue&type=template&id=171b297d&scoped=true"
import script from "./MediaItem.vue?vue&type=script&lang=js"
export * from "./MediaItem.vue?vue&type=script&lang=js"

import "./MediaItem.vue?vue&type=style&index=0&id=171b297d&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\VUE_Tuts\\cybershyft\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171b297d"]])

export default __exports__